module.exports = __webpack_public_path__ + "img/PM.55df0a2e.svg";